module.exports = __webpack_public_path__ + "static/user-graph1-be874d160bd103ae7698ba58b5ac69e2.png";